import { render, staticRenderFns } from "./PublisherActions.vue?vue&type=template&id=ef7ae606"
import script from "./PublisherActions.vue?vue&type=script&lang=js"
export * from "./PublisherActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports